var _ellipse, _polygon, _path, _ellipse2, _polygon2, _ellipse3, _ellipse4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutParking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-33"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "54.38 384.77 54.38 335.46 77.14 335.46 77.14 289.73 80.35 289.73 80.35 315.94 89.1 315.94 89.1 308.69 104.86 308.69 104.86 283.59 107.78 283.59 107.78 252.92 110.11 252.92 110.11 283.04 115.66 283.04 115.66 327.65 126.16 327.65 126.16 283.04 145.13 283.04 145.13 320.77 165.04 320.77 165.04 275.04 168.25 275.04 168.25 301.25 177 301.25 177 294 192.76 294 192.76 268.9 195.68 268.9 195.68 238.22 198.01 238.22 198.01 268.34 203.56 268.34 203.56 312.96 214.06 312.96 214.06 268.34 233.03 268.34 233.03 311.5 245.82 311.5 245.82 286.4 248.74 286.4 248.74 255.73 251.07 255.73 251.07 285.85 256.62 285.85 256.62 330.46 267.12 330.46 267.12 285.85 286.09 285.85 286.09 330.46 295.42 330.46 295.42 335.46 311.78 335.46 311.78 289.73 314.99 289.73 314.99 315.94 323.75 315.94 323.75 308.69 339.5 308.69 339.5 283.59 342.42 283.59 342.42 252.92 344.75 252.92 344.75 283.04 349.84 283.04 349.84 280.52 368.81 280.52 368.81 283.04 379.31 283.04 379.31 280.52 384.86 280.52 384.86 250.41 387.19 250.41 387.19 281.08 390.11 281.08 390.11 306.18 405.87 306.18 405.87 313.43 414.62 313.43 414.62 287.22 417.83 287.22 417.83 332.95 440.59 332.95 440.59 384.77 54.38 384.77",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 348.33,
    cy: 129.64,
    r: 27.79,
    transform: "translate(95.26 401.84) rotate(-67.5)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.74,129.33A4.84,4.84,0,0,1,369,124.7,10.21,10.21,0,0,1,379.08,113a10.71,10.71,0,0,1,1.89.17,8.94,8.94,0,0,1,16.57,4.52h.15a8.24,8.24,0,1,1,0,16.48H367.44A4.82,4.82,0,0,1,362.74,129.33Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.15,205.31a4.8,4.8,0,0,1,6.21-4.62,10.46,10.46,0,0,1-.1-1.49A10.23,10.23,0,0,1,70.49,189a10.6,10.6,0,0,1,1.88.18A8.94,8.94,0,0,1,89,193.67h.15a8.24,8.24,0,1,1,0,16.48H58.84A4.84,4.84,0,0,1,54.15,205.31Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216,147.6a7.65,7.65,0,0,0-9.84-7.32,16.56,16.56,0,0,0,.17-2.35A16.16,16.16,0,0,0,187.18,122,14.14,14.14,0,0,0,161,129.18h-.24a13,13,0,1,0,0,26.07h47.87A7.63,7.63,0,0,0,216,147.6Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.24,213.21a9.19,9.19,0,0,0-11.84-8.81,18.82,18.82,0,0,0,.21-2.82,19.48,19.48,0,0,0-19.48-19.48,20.11,20.11,0,0,0-3.58.33A17,17,0,0,0,287,191h-.28a15.69,15.69,0,1,0,0,31.37h57.6A9.19,9.19,0,0,0,353.24,213.21Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.13,143.8a3,3,0,0,1,3.87-2.88,7,7,0,0,1-.07-.92,6.36,6.36,0,0,1,6.36-6.36,6.45,6.45,0,0,1,1.17.11,5.56,5.56,0,0,1,10.31,2.81h.09a5.12,5.12,0,1,1,0,10.24H305.05A3,3,0,0,1,302.13,143.8Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.82,111.4A3,3,0,0,0,97,108.52a7,7,0,0,0,.07-.92,6.36,6.36,0,0,0-6.36-6.36,6.56,6.56,0,0,0-1.18.11,5.55,5.55,0,0,0-10.3,2.81H79.1a5.13,5.13,0,1,0,0,10.25H97.9A3,3,0,0,0,100.82,111.4Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-33"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-33",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sign--inject-33"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 124.15,
    y: 125.99,
    width: 5.4,
    height: 266.91,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.82,
    y: 115.42,
    width: 48.04,
    height: 48.04,
    rx: 4.78,
    style: {
      fill: "#CC1DDE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.08,161.46H107.61a2.78,2.78,0,0,1-2.78-2.78V120.2a2.78,2.78,0,0,1,2.78-2.78h38.47a2.79,2.79,0,0,1,2.79,2.78v38.48A2.79,2.79,0,0,1,146.08,161.46Zm-38.47-42a.78.78,0,0,0-.78.78v38.48a.78.78,0,0,0,.78.78h38.47a.79.79,0,0,0,.79-.78V120.2a.79.79,0,0,0-.79-.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.15,128c5,0,7.85,2.47,7.85,6.81,0,4.57-2.86,7.21-7.85,7.21h-3.89v5.6h-4.43V128Zm-3.89,10.32h3.67c2.47,0,3.87-1.13,3.87-3.37s-1.4-3.28-3.87-3.28h-3.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.54 392.91 124.15 392.91 124.15 208 129.54 215 129.54 392.91",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.99,
    y: 174.74,
    width: 42.87,
    height: 26.91,
    rx: 2.43,
    style: {
      fill: "#CC1DDE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.99,
    y: 174.74,
    width: 42.87,
    height: 26.91,
    rx: 2.43,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.63,191.75a3.56,3.56,0,1,1-3.55-3.56A3.56,3.56,0,0,1,121.63,191.75Zm12.17-3.56a3.56,3.56,0,1,0,3.56,3.56A3.56,3.56,0,0,0,133.8,188.19Zm-17.64,0s3-1.12,4.65.66A5.61,5.61,0,0,1,122,193.3h7.22l.4-.79c-.7-4.75,5.34-5.35,5.34-5.35l-1.16-1.28,1.16-1.19-.7-1.38-6.23.59-.29,1.48,1.08,1.3-2,5.07h-3.27l-2-4.68.86-1.69-.86-1,1.75-1.13,2.08-.4v-.69l-2.57.2s0-.79-.69-.69a12.37,12.37,0,0,0-2.38,1l.7,1a9.7,9.7,0,0,0-3.07,3.47C115.77,187.07,116.16,188.19,116.16,188.19Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Street--inject-33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.54,387.84v12H90.23v-12a3.57,3.57,0,0,1,3.54-3.77H425A3.57,3.57,0,0,1,428.54,387.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.51,
    y: 384.07,
    width: 21.04,
    height: 15.78,
    style: {
      fill: "#CC1DDE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.83,
    y: 384.07,
    width: 20.16,
    height: 15.78,
    style: {
      fill: "#CC1DDE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.27,
    y: 384.07,
    width: 21.03,
    height: 15.78,
    style: {
      fill: "#CC1DDE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.59,
    y: 384.07,
    width: 20.16,
    height: 15.78,
    style: {
      fill: "#CC1DDE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.03,
    y: 384.07,
    width: 20.16,
    height: 15.78,
    style: {
      fill: "#CC1DDE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.47,
    y: 384.07,
    width: 21.03,
    height: 15.78,
    style: {
      fill: "#CC1DDE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.78,
    y: 384.07,
    width: 20.16,
    height: 15.78,
    style: {
      fill: "#CC1DDE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.22,
    y: 384.07,
    width: 21.03,
    height: 15.78,
    style: {
      fill: "#CC1DDE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.51,
    y: 384.07,
    width: 21.04,
    height: 15.78,
    style: {
      fill: "#fff",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.83,
    y: 384.07,
    width: 20.16,
    height: 15.78,
    style: {
      fill: "#fff",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.27,
    y: 384.07,
    width: 21.03,
    height: 15.78,
    style: {
      fill: "#fff",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.59,
    y: 384.07,
    width: 20.16,
    height: 15.78,
    style: {
      fill: "#fff",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.03,
    y: 384.07,
    width: 20.16,
    height: 15.78,
    style: {
      fill: "#fff",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.47,
    y: 384.07,
    width: 21.03,
    height: 15.78,
    style: {
      fill: "#fff",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.78,
    y: 384.07,
    width: 20.16,
    height: 15.78,
    style: {
      fill: "#fff",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.22,
    y: 384.07,
    width: 21.03,
    height: 15.78,
    style: {
      fill: "#fff",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.54,387.84v12H90.23v-12a3.57,3.57,0,0,1,3.54-3.77H425A3.57,3.57,0,0,1,428.54,387.84Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--vehicle-1--inject-33"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 237.03,
    cy: 373.84,
    rx: 36.32,
    ry: 43.83,
    style: {
      fill: "#2e353a"
    }
  }), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 243.11,
    cy: 373.84,
    rx: 22.91,
    ry: 27.64
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 248.37,
    cy: 373.48,
    rx: 9.54,
    ry: 11.51,
    style: {
      fill: "#CC1DDE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 248.37,
    cy: 373.48,
    rx: 9.54,
    ry: 11.51,
    style: {
      isolation: "isolate",
      opacity: 0.4
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "199.37 331.5 209.39 361.96 204.38 364.12 195.34 337.33 199.37 331.5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M203.58,338.07l-7.15,5.75a1,1,0,0,1-1.44-.16h0a1,1,0,0,1,.16-1.44l7.15-5.75a1,1,0,0,1,1.44.16h0A1,1,0,0,1,203.58,338.07Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.84,341.87l-7.14,5.74a1,1,0,0,1-1.44-.15h0a1,1,0,0,1,.15-1.44l7.15-5.75a1,1,0,0,1,1.44.16h0A1,1,0,0,1,204.84,341.87Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.11,345.66,199,351.41a1,1,0,0,1-1.44-.16h0a1,1,0,0,1,.15-1.44l7.15-5.74a1,1,0,0,1,1.44.15h0A1,1,0,0,1,206.11,345.66Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.37,349.46l-7.15,5.75a1,1,0,0,1-1.44-.16h0a1,1,0,0,1,.15-1.44l7.15-5.75a1,1,0,0,1,1.44.16h0A1,1,0,0,1,207.37,349.46Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.63,353.26,201.48,359a1,1,0,0,1-1.44-.15h0a1,1,0,0,1,.15-1.44l7.15-5.75a1,1,0,0,1,1.44.16h0A1,1,0,0,1,208.63,353.26Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.89,357.06l-7.15,5.74a1,1,0,0,1-1.44-.16h0a1,1,0,0,1,.16-1.44l7.14-5.74a1,1,0,0,1,1.44.15h0A1,1,0,0,1,209.89,357.06Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.94 357.51 265.3 354.33 269.67 359.27 257.62 359.78 250.93 374.96 184.28 377.78 189.94 357.51",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.93 357.09 265.3 354.33 269.67 359.27 257.62 359.78 250.93 374.96 194.28 377.36 199.93 357.09",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.04 379.28 156.67 417.48 159.61 417.48 169.89 387.32 179.16 387.32 183.08 417.48 185.85 417.48 183.82 378.97 168.04 379.28",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,319.13l-5.72,18L91.38,377.72l-4.89-3L99,334.07l5.77-18.78C106.3,316.35,108.07,317.63,110,319.13Z",
    style: {
      fill: "#CC1DDE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,319.13l-5.72,18L91.38,377.72l-4.89-3L99,334.07l5.77-18.78C106.3,316.35,108.07,317.63,110,319.13Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.82,275.15l-20.09,62h-1.52c-2.81-3.34-5.24-3.08-5.24-3.08l-1-1.48,20.6-60C118.65,272.67,123,269.36,125.82,275.15Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.88,373.78c0,3.25-1.84,5.88-4.11,5.88s-4.12-2.63-4.12-5.88,1.85-5.87,4.12-5.87S93.88,370.54,93.88,373.78Z",
    style: {
      fill: "#2e353a"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M251.92,308.49l18,19.62v1.69H262a34.52,34.52,0,0,0-26.11-13.22Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M156.67,324l12.43,47.64,13.19,12.31h0a1.54,1.54,0,0,0,1.53,1.53h9a1.54,1.54,0,0,0,1.54-1.53V359a31,31,0,0,1,7.7-20.43h0a31.16,31.16,0,0,1,10.36-7.7l38.11-17.43-2.77-4.94-63.89,4.15Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.67,324l12.43,47.64,13.19,12.31h0a1.54,1.54,0,0,0,1.53,1.53h9a1.54,1.54,0,0,0,1.54-1.53V359a31,31,0,0,1,7.7-20.43h0a31.16,31.16,0,0,1,10.36-7.7l38.11-17.43-2.77-4.94-63.89,4.15Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.05,
    y: 350.68,
    width: 35.27,
    height: 26.8,
    rx: 5.85,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.33,356.54v15.09a5.86,5.86,0,0,1-5.86,5.85H160.9a5.85,5.85,0,0,1-5.85-5.85V356.54a5.85,5.85,0,0,1,5.85-5.85h23.57A5.86,5.86,0,0,1,190.33,356.54Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.33,356.54v15.09a5.86,5.86,0,0,1-5.86,5.85H175a5.85,5.85,0,0,1-5.85-5.85V356.54a5.85,5.85,0,0,1,5.85-5.85h9.52A5.86,5.86,0,0,1,190.33,356.54Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.75,290.71c4.72-4.74,18-8.88,36,0s25.32,20.11,21.36,25.87-30.26,20.61-47.67,12.59S112.63,298.84,120.75,290.71Z",
    style: {
      fill: "#CC1DDE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.75,290.71c4.72-4.74,18-8.88,36,0s25.32,20.11,21.36,25.87-30.26,20.61-47.67,12.59S112.63,298.84,120.75,290.71Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199,314.36a5.73,5.73,0,0,1-.92,2.22c-4,5.75-30.26,20.61-47.67,12.59s-17.81-30.34-9.69-38.47c4.72-4.72,18-8.87,36,0a71.16,71.16,0,0,1,11.53,7C196.25,303.76,199.89,310,199,314.36Z",
    style: {
      fill: "#CC1DDE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.3,303.06h22.63a4,4,0,0,0,4-4v-8.27c0-2.22-1.34-6.17-3.56-6.17l-19.87,2.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,372h-8.27a6.19,6.19,0,0,1-5.47-3.26c-4.33-8.12-16.93-28.91-34.64-34-22.13-6.39,12-10.23,24.33-1.4S145,372,145,372Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,372h-8.27a6.19,6.19,0,0,1-5.47-3.26c-4.33-8.12-16.93-28.91-34.64-34-22.13-6.39,12-10.23,24.33-1.4S145,372,145,372Z",
    style: {
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.62,
    cy: 375.54,
    rx: 34.92,
    ry: 42.13,
    style: {
      fill: "#2e353a"
    }
  }), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 102.47,
    cy: 375.54,
    rx: 22.02,
    ry: 26.57
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 107.52,
    cy: 375.18,
    rx: 9.17,
    ry: 11.07,
    style: {
      fill: "#CC1DDE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 107.52,
    cy: 375.18,
    rx: 9.17,
    ry: 11.07,
    style: {
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.41,349.16h3.88a14.84,14.84,0,0,0,8.93-3c6-4.51,18.77-12.08,32-7.69,15.33,5.08,25.74,25.19,28.71,31.56A3.36,3.36,0,0,0,145,372h0s-4.82-39.38-31.77-50.08c-26.14-10.38-43.84,11.46-47.65,23.39A3,3,0,0,0,68.41,349.16Z",
    style: {
      fill: "#CC1DDE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131,319.13l-5.73,18-12.89,40.57-4.89-3L120,334.07l5.77-18.78C127.3,316.35,129.07,317.63,131,319.13Z",
    style: {
      fill: "#CC1DDE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131,319.13l-5.73,18-12.89,40.57-4.89-3L120,334.07l5.77-18.78C127.3,316.35,129.07,317.63,131,319.13Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.82,275.15l-20.08,62h-1.52c-2.82-3.34-5.25-3.08-5.25-3.08l-1-1.48,20.6-60C139.66,272.67,144,269.36,146.82,275.15Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.89,373.78c0,3.25-1.85,5.88-4.12,5.88s-4.11-2.63-4.11-5.88,1.84-5.87,4.11-5.87S114.89,370.54,114.89,373.78Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.29,288.35S118,303,110.3,303.06c-7.18.1-7.85-13.62-1-15.73C114.84,285.63,120.29,288.35,120.29,288.35Z",
    style: {
      fill: "#CC1DDE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.29,288.35S118,303,110.3,303.06c-7.18.1-7.85-13.62-1-15.73C114.84,285.63,120.29,288.35,120.29,288.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105,295.07c-.17,3.71,2.07,6.72,5,6.72s5.43-3,5.6-6.72-2.06-6.72-5-6.72S105.17,291.36,105,295.07Z",
    style: {
      fill: "#CC1DDE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105,295.07c-.17,3.71,2.07,6.72,5,6.72s5.43-3,5.6-6.72-2.06-6.72-5-6.72S105.17,291.36,105,295.07Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.61,296.82c0,1.64-1,3-2.31,3s-2.31-1.33-2.31-3,1-3,2.31-3S111.61,295.18,111.61,296.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.56,293a1.19,1.19,0,1,1-1.16-1.49A1.35,1.35,0,0,1,113.56,293Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.43,288.35s-2.32,14.61-10,14.71c-7.19.1-7.86-13.62-1-15.73C127,285.63,132.43,288.35,132.43,288.35Z",
    style: {
      fill: "#CC1DDE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.43,288.35s-2.32,14.61-10,14.71c-7.19.1-7.86-13.62-1-15.73C127,285.63,132.43,288.35,132.43,288.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 122.45,
    cy: 295.07,
    rx: 6.74,
    ry: 5.29,
    transform: "translate(-185.13 381.4) rotate(-83.14)",
    style: {
      fill: "#CC1DDE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 122.45,
    cy: 295.07,
    rx: 6.74,
    ry: 5.29,
    transform: "translate(-185.13 381.4) rotate(-83.14)",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.75,296.82c0,1.64-1,3-2.31,3s-2.3-1.33-2.3-3,1-3,2.3-3S123.75,295.18,123.75,296.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 124.55,
    cy: 292.96,
    rx: 1.15,
    ry: 1.49,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,298h0a1,1,0,0,0,.92-.66l6.73-19.8a1.48,1.48,0,0,0-1.4-1.95H123a3.11,3.11,0,0,0-2.48,1.22l-7.55,9.85h16.6a2.52,2.52,0,0,1,2.52,2.52V297A1,1,0,0,0,133,298Z",
    style: {
      fill: "#CC1DDE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.38,316.58h-22a1.7,1.7,0,0,1-1.67-2.49l3.25-8.54a4.12,4.12,0,0,1,3.57-2.49h22a1.7,1.7,0,0,1,1.68,2.49L131,314.09A4.15,4.15,0,0,1,127.38,316.58Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.38,316.58h-22a1.7,1.7,0,0,1-1.67-2.49l3.25-8.54a4.12,4.12,0,0,1,3.57-2.49h22a1.7,1.7,0,0,1,1.68,2.49L131,314.09A4.15,4.15,0,0,1,127.38,316.58Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 176.88,
    cy: 364.08,
    rx: 6.99,
    ry: 11.54,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.72,336.14l3.39,10.32a3.41,3.41,0,0,0,3.23,2.33h12.44a3.38,3.38,0,0,0,2.8-1.47l8.62-12.49a3.4,3.4,0,0,0-.73-4.63l-6.38-4.88a3.39,3.39,0,0,0-3.63-.31c-3.48,1.8-11.06,5.49-17.18,6.74A3.39,3.39,0,0,0,172.72,336.14Z",
    style: {
      fill: "#CC1DDE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.47,359l8.62,19.2a9.21,9.21,0,0,0,8.65,5.44c7.17-.19,18.13.18,18.13.18a11.11,11.11,0,0,0,2-6.46H172.07a6.91,6.91,0,0,1-6.54-4.67L161,359.33Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,336.77l0,.56-.08,1-.21,2.53-.07,1-.21,2.53-.08,1-.2,2.53-.08,1-.2,2.55-.08,1-.25,3.11a4.22,4.22,0,0,1-4.21,3.88H147a4.21,4.21,0,0,1-4.08-3.14l-1-3.85-.26-1-.67-2.55-.25-1-.67-2.53-.26-1-.67-2.53-.25-1-.67-2.53-.26-1-.59-2.25a4.25,4.25,0,0,1,1.84-4.65,4.25,4.25,0,0,1,2.24-.63h19.21a4.18,4.18,0,0,1,2.55.85l3.19,2.42A4.19,4.19,0,0,1,168,336.77Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,336.77l0,.56-.08,1-.21,2.53-.07,1-.21,2.53-.08,1-.2,2.53-.08,1-.2,2.55-.08,1-.25,3.11a4.22,4.22,0,0,1-4.21,3.88H147a4.21,4.21,0,0,1-4.08-3.14l-1-3.85-.26-1-.67-2.55-.25-1-.67-2.53-.26-1-.67-2.53-.25-1-.67-2.53-.26-1-.59-2.25a4.25,4.25,0,0,1,1.84-4.65,4.25,4.25,0,0,1,2.24-.63h19.21a4.18,4.18,0,0,1,2.55.85l3.19,2.42A4.19,4.19,0,0,1,168,336.77Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,336.77l0,.56-.08,1-.21,2.53-.07,1-.21,2.53-.08,1-.2,2.53-.08,1-.2,2.55-.08,1-.25,3.11a4.22,4.22,0,0,1-4.21,3.88H161a4.21,4.21,0,0,1-4.08-3.14l-1-3.85-.26-1-.67-2.55-.25-1-.67-2.53-.26-1-.67-2.53-.25-1-.67-2.53-.26-1-.59-2.25a4.25,4.25,0,0,1,1.84-4.65,4.25,4.25,0,0,1,2.24-.63h5.21a4.18,4.18,0,0,1,2.55.85l3.19,2.42A4.19,4.19,0,0,1,168,336.77Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.98 337.33 167.9 338.31 138.18 338.31 137.92 337.33 167.98 337.33",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.69 340.85 167.62 341.81 139.1 341.81 138.85 340.85 167.69 340.85",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.41 344.36 167.33 345.32 140.03 345.32 139.77 344.36 167.41 344.36",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.13 347.87 167.05 348.83 140.95 348.83 140.7 347.87 167.13 347.87",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.85 351.38 166.77 352.35 141.88 352.35 141.62 351.38 166.85 351.38",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.85,377.33a11.24,11.24,0,0,1-1.9,6.34.68.68,0,0,1-.08.11s-5.44-.18-11.16-.22h-4.09c-1,0-2,0-2.89,0a9.18,9.18,0,0,1-8.64-5.43L148.46,359l4,.11,8.46.25,4.56,13.33a6.92,6.92,0,0,0,6.53,4.67Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.85,377.33a11.24,11.24,0,0,1-1.9,6.34c-3-.07-7.36-.15-11.24-.11h-.78l-2.2,0a10.22,10.22,0,0,1-1.11,0,9.23,9.23,0,0,1-7.53-5.4l-8.58-19.08,8.46.25,4.56,13.33a6.92,6.92,0,0,0,6.53,4.67Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199,311.66l.71,0a1.42,1.42,0,0,1,1.39,1.44c0,1.38,0,3.45,0,4.66,0,2.68,4.93,7.74,5.91,8s47.08-14.28,47.08-14.28.79-9.93-3.56-11.93-28.4.13-30.46,2.2-9,6.7-16.27,6.7C203.8,308.49,199,309.77,199,311.66Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267,299.8l-20.22,19.64-24,7.14-.73-5.07,23.63-16.74a2,2,0,0,0,.67-2.39l-.45-1.05a2.19,2.19,0,0,0-2-1.34H225.65s3.91-1.35,7.27-2.55,26.31,0,29.67,0a5.05,5.05,0,0,1,3.64,1.34A3.67,3.67,0,0,1,267,299.8Z",
    style: {
      fill: "#CC1DDE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.62,277.83s8.3.2,12.62-9.1h6.87v3l19.4,6.11s.39,3.24-.79,3.89l-21.17-5.54H153s-4.15,5.35-9,5.6S141.62,277.83,141.62,277.83Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.52,273.67v4.49s9.21,1.71,12.52,5.27v1.19h1.19v-1.19s-.95-2.28-9.62-6.06v-3.7Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.48,276.79a19,19,0,0,1-1.52-7.34h-5.4l-1.16,2.77-11.87,9s-.82,2.9,3,2.51l10.56-7.11-.55,2.18s-5.11,2.89-6.57,5,1.32,1.76,1.32,1.76l.13-1.79s3.53-3.45,7.17-3.51Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199,314.36c-3.84,7.65-22,14.48-29.8,12.22s-21.76-13.75-9.62-18.08c9.7-3.49,23.51-8.8,28.67-10.78C196.25,303.76,199.89,310,199,314.36Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.31,302.38l-.45-1.05a2.19,2.19,0,0,0-2-1.34H225.65s3.91-1.35,7.27-2.55,26.31,0,29.67,0a5.05,5.05,0,0,1,3.64,1.34s-14.6,1.74-20.59,6A2,2,0,0,0,246.31,302.38Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.36,377.06l18.39-1.58s10.38-3.68,12.9-3.7,27.25-1.12,27.25-1.12,3.57,2.4,4.36,4.82-3.15,7.51-3.15,7.51-39.29,1.29-40.92,1.26a10.2,10.2,0,0,1-3.8-1.26l-15-1.05Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.36,377.06l18.39-1.58s10.38-3.68,12.9-3.7,27.25-1.12,27.25-1.12,3.57,2.4,4.36,4.82-3.15,7.51-3.15,7.51-39.29,1.29-40.92,1.26a10.2,10.2,0,0,1-3.8-1.26l-15-1.05Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--vehicle-2--inject-33"
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "257.34 417.67 264.63 397.39 278.71 397.39 277.92 417.67 275.34 417.67 274.16 399.56 267.45 399.56 259.52 417.67 257.34 417.67"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M314.71,387.26l-3.91,9a9.52,9.52,0,0,1-8.73,5.73H285.68a8.21,8.21,0,0,1-5.8-2.4H249.26a7.48,7.48,0,0,1-6.06-3.11l-4-5.62Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.71,387.26l-3.91,9a9.52,9.52,0,0,1-8.73,5.73H285.68a8.21,8.21,0,0,1-5.8-2.4H249.26a7.48,7.48,0,0,1-6.06-3.11l-4-5.62Z",
    style: {
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.22,289.1a.31.31,0,0,1-.13,0,.33.33,0,0,1-.18-.43c1.25-3.08,7.84-5.79,13-6.29a33.76,33.76,0,0,0,4.8-.63.31.31,0,0,1,.28-.05.34.34,0,0,1,.23.42c-.07.24-.13.42-5.24.93-4.93.48-11.3,3.1-12.42,5.87A.35.35,0,0,1,243.22,289.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.91,288.7a.27.27,0,0,1-.14,0c-2.21-1.07-2.62-2.52-3.19-4.52l-.07-.28c-.51-1.79-2.6-1.54-2.68-1.53a.33.33,0,0,1-.38-.29.34.34,0,0,1,.29-.38,3,3,0,0,1,3.41,2l.08.28c.53,1.9.89,3.16,2.83,4.1a.34.34,0,0,1,.16.45A.34.34,0,0,1,225.91,288.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369,379.28h-1.89v-2.9h3.78A3.47,3.47,0,0,1,369,379.28Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 339.87,
    cy: 387.32,
    rx: 25.15,
    ry: 30.35,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 339.87,
    cy: 387.32,
    rx: 25.15,
    ry: 30.35,
    style: {
      isolation: "isolate",
      opacity: 0.4
    }
  }), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 344.08,
    cy: 387.32,
    rx: 15.86,
    ry: 19.14
  })), /*#__PURE__*/React.createElement("path", {
    d: "M347.72,379.09c3.65,0,6.61,3.57,6.61,8s-3,8-6.61,8-6.61-3.57-6.61-8S344.07,379.09,347.72,379.09Z",
    style: {
      fill: "#CC1DDE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.72,379.09c3.65,0,6.61,3.57,6.61,8s-3,8-6.61,8-6.61-3.57-6.61-8S344.07,379.09,347.72,379.09Z",
    style: {
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.51,371.77s2.84,6.15,0,11a64.84,64.84,0,0,1-27.21,6.54C324.45,389.33,343.76,370.34,366.51,371.77Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.51,371.77s2.84,6.15,0,11a64.84,64.84,0,0,1-27.21,6.54C324.45,389.33,343.76,370.34,366.51,371.77Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.2,333.3s2.43.75,2.43,6.21c0,3.32-3.37,6.66-3.37,6.66S349.85,333.12,356.2,333.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.2,333.3s2.43.75,2.43,6.21c0,3.32-3.37,6.66-3.37,6.66S349.85,333.12,356.2,333.3Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.3,331.8h12s1.86,3.19-3,6.92S345.3,331.8,345.3,331.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.88,338.09c0,1.07-.33,1.94-.75,1.94s-.74-.87-.74-1.94.33-1.93.74-1.93S357.88,337,357.88,338.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.77,351.57c0,4.31-17.21,35-18.93,36.19s-24.18-.14-24.18-.14l1.68,6.36H310l25.61-49.75-16.94-24.44-30.88.85S289.77,347.26,289.77,351.57Z",
    style: {
      fill: "#CC1DDE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.77,351.57c0,4.31-17.21,35-18.93,36.19s-24.18-.14-24.18-.14l1.68,6.36H310l25.61-49.75-16.94-24.44-30.88.85S289.77,347.26,289.77,351.57Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.73,341.48s20.06,15.38,29.66,47a8.77,8.77,0,0,0,8.39,6.28h29.67l-34.44-56-18.17-7.56Z",
    style: {
      fill: "#CC1DDE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.35,339.71s22.19,17,32,48.83a8.78,8.78,0,0,0,8.38,6.24h29.69l-34.44-56-18.17-7.56Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.23,368.8a2.41,2.41,0,0,1-2.43,2.13h-4.36a2.83,2.83,0,0,0-2.11.94l-13.05,14.39a5.72,5.72,0,0,1-1.36,1.09,58,58,0,0,1-28.38,7.43h-61a6.49,6.49,0,0,1-6.4-6c-1.48-17.62-12.09-30.57-21-38.51a83.35,83.35,0,0,0-9-7,13.42,13.42,0,0,0-7.5-2.19h-14c-1.77,0-3-2.26-2.48-3.94,2.31-7,6.6-14.57,10.88-21.05a182.15,182.15,0,0,1,12.46-16.66h19.63a6.08,6.08,0,0,1,5,2.76,6.79,6.79,0,0,1,1.17,4.93,89.4,89.4,0,0,0-.26,24.39c2.81,23.94,13.46,45.71,19,55.62a11.51,11.51,0,0,0,9.83,6h15.26c11.15-3.2,19.77-34.42,19.77-42.57,0-8.62-8.77-29.52-8.77-29.52h43.7v10.39c.8.09.4.2.66.32,16.74,6.72,22.58,23.89,24.66,33.88A10.29,10.29,0,0,1,370.23,368.8Z",
    style: {
      fill: "#CC1DDE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.41,331.8c-.26-.12.14-.23-.66-.32V321.09h-43.7s8.77,20.9,8.77,29.52c0,8.15-8.62,39.36-19.77,42.56H274.79a11.5,11.5,0,0,1-9.83-6c-5.56-9.91-16.21-31.68-19-55.63a88.94,88.94,0,0,1,.26-24.38,6.84,6.84,0,0,0-1.17-4.93,6.1,6.1,0,0,0-5-2.76H220.42A182.15,182.15,0,0,0,208,316.13c-4.28,6.48-8.57,14-10.88,21.05-.55,1.68.71,3.94,2.48,3.94h14a13.37,13.37,0,0,1,7.5,2.19,83.06,83.06,0,0,1,9,7c8.93,7.94,19.55,20.9,21,38.51a6.5,6.5,0,0,0,6.4,6h50.74V375.46a38.52,38.52,0,0,1,3.63-16.32l7.22-15.46a20.51,20.51,0,0,1,18.6-11.83h6.76l.78-.05C347,332.47,347.05,332.46,345.41,331.8Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,293h5.59a6.47,6.47,0,0,0,4.05-1.43l11.53-9.33a2.53,2.53,0,0,1,1.61-.57H276a1.6,1.6,0,1,0,0-3.2H253.82a5.76,5.76,0,0,0-3.63,1.28l-11.53,9.33a3.25,3.25,0,0,1-2,.72H231a3.25,3.25,0,0,1-3.2-2.78l-.51-3.6a5.79,5.79,0,0,0-5.71-4.95h-4.21a1.6,1.6,0,0,0,0,3.2h4.21a2.58,2.58,0,0,1,2.54,2.2l.51,3.6A6.47,6.47,0,0,0,231,293Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.05,297.27l-2.5,4H219.29l-1.82-3.44a2.91,2.91,0,0,1,.49-3.43l6.91-7.07a3.84,3.84,0,0,1,.88-.68,3.48,3.48,0,0,1,.52-.24,3.84,3.84,0,0,1,1.38-.26h13.26s-.07,3.79,3.47,3.55l1.16,4.1A4.31,4.31,0,0,1,245.05,297.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.15,291.26l-7.41-.26,1-4.33a3.48,3.48,0,0,1,.52-.24,3.84,3.84,0,0,1,1.38-.26h11.56Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.88,320v3c0,2.73,2.24,4.5,5,4.5H343c2.74,0,4.94-1.77,4.94-4.5v-3c0-2.73-2.2-4.5-4.94-4.5H288.85C286.12,315.49,283.88,317.26,283.88,320Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.5,320v3a4.3,4.3,0,0,0,4.61,4.5H343c2.74,0,4.94-1.77,4.94-4.5v-3c0-2.73-2.2-4.5-4.94-4.5h-36.9A4.3,4.3,0,0,0,301.5,320Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.24,
    y: 272.98,
    width: 14.28,
    height: 1.6,
    transform: "translate(-115.66 313.51) rotate(-52.59)",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.3,266.23h-4.08a2.16,2.16,0,0,0-2,1.32l-.55,1.27a2.17,2.17,0,0,0,2,3h4.45a2.16,2.16,0,0,0,2.14-1.86l.19-1.27A2.18,2.18,0,0,0,268.3,266.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.81,
    y: 269.46,
    width: 1.6,
    height: 10.37,
    transform: "translate(-51.81 51.75) rotate(-11.89)",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.75,266.23h4.4a1.8,1.8,0,0,1,1.77,1.54l.29,2a1.79,1.79,0,0,1-1.77,2H217a1.79,1.79,0,0,1-1.77-1.53l-.29-2A1.8,1.8,0,0,1,216.75,266.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.6,312a89.15,89.15,0,0,0-.16,14.24c.12,1.8.29,3.57.5,5.34L238.89,345a9.86,9.86,0,0,1-8.75,5.3h0l-.09,0a13.41,13.41,0,0,0-1.07-1,81.9,81.9,0,0,0-7.68-5.84,13.79,13.79,0,0,0-7.71-2.33h-14c-1.77,0-3-2.26-2.48-3.94,2.31-7,6.6-14.57,10.88-21.05a126,126,0,0,1-1.71,22.59H213s12.3-17.43,22.76-20.79l9.28-15.7a6.79,6.79,0,0,1,1.17,4.93C246,308.76,245.75,310.36,245.6,312Z",
    style: {
      fill: "#CC1DDE",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.6,312a89.15,89.15,0,0,0-.16,14.24c.12,1.8.29,3.57.5,5.34L238.89,345a9.86,9.86,0,0,1-8.75,5.3h0l-.09,0a13.41,13.41,0,0,0-1.07-1,81.9,81.9,0,0,0-7.68-5.84,13.79,13.79,0,0,0-7.71-2.33h-14c-1.77,0-3-2.26-2.48-3.94,2.31-7,6.6-14.57,10.88-21.05a126,126,0,0,1-1.71,22.59H213s12.3-17.43,22.76-20.79l9.28-15.7a6.79,6.79,0,0,1,1.17,4.93C246,308.76,245.75,310.36,245.6,312Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.25,320.94a38.64,38.64,0,0,1-1.82,14.72h-5.78S202.4,325.45,206.25,320.94Z",
    style: {
      fill: "#CC1DDE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.25,320.94a38.64,38.64,0,0,1-1.82,14.72h-5.78S202.4,325.45,206.25,320.94Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.59,320.94c.19-.11-5.81,15.79-5.81,15.79H219A39.65,39.65,0,0,1,233.59,320.94Z",
    style: {
      fill: "#CC1DDE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.59,320.94c.19-.11-5.81,15.79-5.81,15.79H219A39.65,39.65,0,0,1,233.59,320.94Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.37,332.38c0,2-1.24,3.57-2.77,3.57s-2.77-1.59-2.77-3.57,1.24-3.57,2.77-3.57S228.37,330.41,228.37,332.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.1,331.19c0,2-.87,3.57-1.95,3.57s-2-1.6-2-3.57.87-3.57,2-3.57S205.1,329.22,205.1,331.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.92,327a1.4,1.4,0,1,1-1.35-1.75A1.58,1.58,0,0,1,230.92,327Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.83,326.09c0,1-.42,1.75-.93,1.75s-.93-.78-.93-1.75.41-1.74.93-1.74S205.83,325.13,205.83,326.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.67,302.17s-4.16,26.16-17.89,26.35c-12.86.17-14.06-24.4-1.79-28.18C222.91,297.29,232.67,302.17,232.67,302.17Z",
    style: {
      fill: "#CC1DDE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.67,302.17s-4.16,26.16-17.89,26.35c-12.86.17-14.06-24.4-1.79-28.18C222.91,297.29,232.67,302.17,232.67,302.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 214.78,
    cy: 314.2,
    rx: 12.06,
    ry: 9.47,
    transform: "translate(-122.81 489.93) rotate(-83.14)",
    style: {
      fill: "#CC1DDE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 214.78,
    cy: 314.2,
    rx: 12.06,
    ry: 9.47,
    transform: "translate(-122.81 489.93) rotate(-83.14)",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.12,317.34c0,2.94-1.85,5.32-4.13,5.32s-4.13-2.38-4.13-5.32S210.71,312,213,312,217.12,314.4,217.12,317.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.61,310.42a2.13,2.13,0,1,1-2.06-2.66A2.42,2.42,0,0,1,220.61,310.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.52,363.29h-4.09a1.3,1.3,0,0,0-1.29,1.3v2.29a1.3,1.3,0,0,0,1.29,1.3h4.85A6.17,6.17,0,0,0,369.52,363.29Z",
    style: {
      fill: "#CC1DDE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.52,363.29h-4.09a1.3,1.3,0,0,0-1.29,1.3v2.29a1.3,1.3,0,0,0,1.29,1.3h4.85A6.17,6.17,0,0,0,369.52,363.29Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.36,278.44s-.13-.79-2.19-.79-2.78,3-2.78,3l.82,2.52H263l1.35-.48s5.1,1.32,5.56,2.16,1.2,1,1,0-5.73-3.24-5.73-3.24Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.23,278.67a1.78,1.78,0,0,0-1.61-1,1.69,1.69,0,0,0-1.93,1.6,9.61,9.61,0,0,0,0,1.86l-1.14.89s-3.48,1.64-3.77,1.87-.43,1.16.18,1.07a14.46,14.46,0,0,0,2.67-1.59,8,8,0,0,1,3-.76l2.11-1.29Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.67 341.58 192.81 386.71 196.33 388.89 210.24 345.09 206.67 341.58",
    style: {
      fill: "#CC1DDE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.67 341.58 192.81 386.71 196.33 388.89 210.24 345.09 206.67 341.58",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.44,341.12l-5.78,18.55h-1.09c-2-2.41-3.78-2.22-3.78-2.22l-.72-1.06,4.38-15.27Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.13,386.06c0,2.33-1.33,4.23-3,4.23s-3-1.9-3-4.23,1.33-4.23,3-4.23S198.13,383.72,198.13,386.06Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 201.02,
    cy: 387.32,
    rx: 25.15,
    ry: 30.35,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 201.02,
    cy: 387.32,
    rx: 25.15,
    ry: 30.35,
    style: {
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.87,384.75h-6A4.48,4.48,0,0,1,226,382.4c-3.12-5.84-12.19-20.82-24.95-24.51-15.94-4.61,8.67-7.37,17.53-1S235.87,384.75,235.87,384.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.87,384.75h-6A4.48,4.48,0,0,1,226,382.4c-3.12-5.84-12.19-20.82-24.95-24.51-15.94-4.61,8.67-7.37,17.53-1S235.87,384.75,235.87,384.75Z",
    style: {
      isolation: "isolate",
      opacity: 0.4
    }
  }), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 205.23,
    cy: 387.32,
    rx: 15.86,
    ry: 19.14
  })), /*#__PURE__*/React.createElement("path", {
    d: "M208.88,379.09c3.65,0,6.6,3.57,6.6,8s-2.95,8-6.6,8-6.61-3.57-6.61-8S205.23,379.09,208.88,379.09Z",
    style: {
      fill: "#CC1DDE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.88,379.09c3.65,0,6.6,3.57,6.6,8s-2.95,8-6.6,8-6.61-3.57-6.61-8S205.23,379.09,208.88,379.09Z",
    style: {
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.7,368.32h2.8a10.75,10.75,0,0,0,6.43-2.16c4.34-3.25,13.52-8.7,23.06-5.54,11,3.66,18.54,18.14,20.68,22.73a2.41,2.41,0,0,0,2.2,1.4h0S232.4,356.39,213,348.68c-18.83-7.48-31.58,8.26-34.33,16.85A2.14,2.14,0,0,0,180.7,368.32Z",
    style: {
      fill: "#CC1DDE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.7,368.32h2.8a10.75,10.75,0,0,0,6.43-2.16c4.34-3.25,13.52-8.7,23.06-5.54,11,3.66,18.54,18.14,20.68,22.73a2.41,2.41,0,0,0,2.2,1.4h0S232.4,356.39,213,348.68c-18.83-7.48-31.58,8.26-34.33,16.85A2.14,2.14,0,0,0,180.7,368.32Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.78,346.69l-4.12,13-9.28,29.22-3.53-2.18,9-29.26L222,343.92C223.12,344.69,224.39,345.61,225.78,346.69Z",
    style: {
      fill: "#CC1DDE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.78,346.69l-4.12,13-9.28,29.22-3.53-2.18,9-29.26L222,343.92C223.12,344.69,224.39,345.61,225.78,346.69Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.57,347.3l-3.86,12.37h-1.09c-2-2.41-3.78-2.22-3.78-2.22l-.72-1.06,3.78-13.19a.93.93,0,0,1,.19.11l.91.61c1.12.77,2.39,1.69,3.78,2.77Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.18,386.06c0,2.33-1.33,4.23-3,4.23s-3-1.9-3-4.23,1.33-4.23,3-4.23S214.18,383.72,214.18,386.06Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.23,368.8a2.41,2.41,0,0,1-2.43,2.13h-4.36a2.83,2.83,0,0,0-2.11.94l-13.05,14.39a5.72,5.72,0,0,1-1.36,1.09,58,58,0,0,1-28.38,7.43H308.32V375.47a38.52,38.52,0,0,1,3.62-16.33l7.22-15.45a20.51,20.51,0,0,1,18.6-11.84h6.76l.78-.05a35.87,35.87,0,0,1,15.92,12.75c.4.54.78,1.1,1.15,1.66a48.12,48.12,0,0,1,3.18,5.75,51.52,51.52,0,0,1,2.06,5,63,63,0,0,1,2.46,8.71A10.29,10.29,0,0,1,370.23,368.8Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.8,291.59a4.19,4.19,0,0,0-.55,1.17c-.15.53-.29,1.07-.43,1.61-1.21,4.78-2.05,10.3-.28,15.05.74,2,2.48,4.85,4.67,5.5,1.63.49,4,.13,5.73.18l6.1.18a2.74,2.74,0,0,0,1.18-.14,2.69,2.69,0,0,0,.95-.89,54.34,54.34,0,0,0,3.08-4.56,15.34,15.34,0,0,0,2.22-5.26,12.46,12.46,0,0,0-1.05-6.79,12.69,12.69,0,0,0-5.84-6.77,14.41,14.41,0,0,0-2.31-.82C317,289.14,309.22,288.15,306.8,291.59Z",
    style: {
      fill: "#CC1DDE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.8,291.59a4.19,4.19,0,0,0-.55,1.17c-.15.53-.29,1.07-.43,1.61-1.21,4.78-2.05,10.3-.28,15.05.74,2,2.48,4.85,4.67,5.5,1.63.49,4,.13,5.73.18l6.1.18a2.74,2.74,0,0,0,1.18-.14,2.69,2.69,0,0,0,.95-.89,54.34,54.34,0,0,0,3.08-4.56,15.34,15.34,0,0,0,2.22-5.26,12.46,12.46,0,0,0-1.05-6.79,12.69,12.69,0,0,0-5.84-6.77,14.41,14.41,0,0,0-2.31-.82C317,289.14,309.22,288.15,306.8,291.59Z",
    style: {
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.24,289.74s-9.64-3.75-17.35.75,10.84,8,10.84,8l-4.11-3.26s5.4,3.08,8.12,2.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.72,310.1a5.1,5.1,0,0,0,3.78,4c4.43,1,11.62-2.52,11.62-2.52l.38,2s-7.1,3.14-12,2.06C306.92,315.05,305,311.81,305.72,310.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.2,315.84l-.26-1.58a10,10,0,0,0-2.22-1,3,3,0,0,0-1.44,0,2.24,2.24,0,0,0,1.18,2.17A6.16,6.16,0,0,0,311.2,315.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.2,315.84l-.26-1.58a10,10,0,0,0-2.22-1,3,3,0,0,0-1.44,0,2.24,2.24,0,0,0,1.18,2.17A6.16,6.16,0,0,0,311.2,315.84Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.14,310.47c-3.39,4.86-9.07,7.68-12.19,4.06s1.33-17.15,1.33-17.15c-7.25-4.38-15.94-3.71-15.94-3.71.6-5.37,7.54-10.92,19.68-6.18a14.22,14.22,0,0,1,8.25,7.65,9.34,9.34,0,0,1,.42,1.11,13.3,13.3,0,0,1,.6,2.31,16.06,16.06,0,0,1,.25,2.66A16.38,16.38,0,0,1,333.14,310.47Z",
    style: {
      fill: "#CC1DDE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.66,291.49a29.81,29.81,0,0,1,17.1,3.43,29.18,29.18,0,0,1,1.09,4.68c0,1.08-21.58-3.48-22.66-4.91s3.11-1.32,3.11-1.32Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.47,217.13c-.16,3.86,1.43,10.1,4.44,12.11,0,0-2,4.15-9,5.42-7.67,1.4-4.25-3.11-4.25-3.11,4-1.76,3.44-4.82,2.27-7.58Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.34,213.91c.13.49,0,1-.36,1.07s-.69-.24-.82-.74,0-1,.36-1.06S371.21,213.41,371.34,213.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.67,213.16h-1.28S370.24,213.92,370.67,213.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371,214.51a14.37,14.37,0,0,1-1,3.68,2.24,2.24,0,0,0,1.86-.18Z",
    style: {
      fill: "#a02724"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.83,210.79a.48.48,0,0,0,.14,0,2.5,2.5,0,0,1,2.2-.33.3.3,0,1,0,.23-.56,3.13,3.13,0,0,0-2.77.38.3.3,0,0,0-.08.42A.29.29,0,0,0,369.83,210.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.67,207.8c1.18,6.21,1.81,8.81-.48,12.82-3.45,6-11.35,6.35-14.36.68-2.71-5.11-4.18-14.4,1.19-18.54A8.45,8.45,0,0,1,387.67,207.8Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390,202.83c-2.65-4.55-5.7-7-14.32-4.55-6.47,1.84-12,11-1.49,16.24,0,0,3,4.25,6.39,5.8s4.31,2,7.87-.1C391.35,218.48,394.06,209.8,390,202.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.62,213.38a5.72,5.72,0,0,1,0,3.45c-.47,1.57-1.67,1.62-2.34.57a4.26,4.26,0,0,1-.23-4.21C373.91,211.92,375.17,212.15,375.62,213.38Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.71,200.14s.55-5.55,5.54-5.58,9,5,9.39,13.81,10.53,5.42,13,7.1,2.6,3.5,2.6,3.5a3.79,3.79,0,0,0-4.07-2.06,2.83,2.83,0,0,1,2,2.36,3.18,3.18,0,0,0-2.27-.59s.87,2.46-4.92,2.62-12.6-1-16.44-9.94S386.71,200.14,386.71,200.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410,212.86a7.07,7.07,0,0,1-3.67-1c-2-1.22-3.37-3.47-4-6.68-.92-4.31-2.65-7.06-5.16-8.17-3.5-1.55-7.37.67-7.41.69a.26.26,0,1,1-.26-.44c.17-.1,4.13-2.38,7.87-.72,2.67,1.18,4.51,4.05,5.46,8.54.64,3.06,1.92,5.19,3.8,6.34a6.81,6.81,0,0,0,4.89.76.26.26,0,0,1,.32.18.25.25,0,0,1-.18.31A6.11,6.11,0,0,1,410,212.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.53,214.34a11.43,11.43,0,0,1-7.08-2.54,6,6,0,0,1-2.32-4.67c0-5,5.68-5.64,5.73-5.65a.26.26,0,1,1,.06.51c-.21,0-5.24.63-5.28,5.15a5.55,5.55,0,0,0,2.14,4.27,10.83,10.83,0,0,0,8.11,2.31.27.27,0,0,1,.3.21.26.26,0,0,1-.21.29A8.69,8.69,0,0,1,376.53,214.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.94,285.55s5.19-15.65,10.16-26.25l.91,1.62s-7.84,19.58-8.45,23.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.94,285.55s5.19-15.65,10.16-26.25l.91,1.62s-7.84,19.58-8.45,23.92Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.11,233.3c.36,1.88.75,3.91,1.2,5.85s.88,3.92,1.4,5.84a75.24,75.24,0,0,0,3.8,11.14l5.22,11.2L420.3,273c.82,1.91,1.67,3.8,2.46,5.73l-3.36,1.82c-1.18-1.72-2.3-3.47-3.44-5.22l-3.31-5.29c-2.18-3.56-4.3-7.1-6.34-10.83a64,64,0,0,1-4.92-12.14c-.61-2.06-1.18-4.13-1.67-6.21s-.9-4.14-1.23-6.36Z",
    style: {
      fill: "#dc897c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.45,278.43s3.46,4.9,3.55,5.56.29,3.59.07,3.66-4.47.51-4.47.51L419,283.67s-.7-2.82-.11-4.37Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.76,241.2c-1,2-2,3.84-3.06,5.71s-2.24,3.65-3.44,5.44A63.88,63.88,0,0,1,359,262.48c-3.06,3-6.13,5.71-9.27,8.47L345,275c-1.61,1.32-3.2,2.67-4.84,4l-2.67-2.74c1.33-1.61,2.7-3.16,4.06-4.74l4.13-4.66,8.31-9.15a74.56,74.56,0,0,0,6.93-9.51C362,246.5,363,244.76,364,243s2-3.55,2.88-5.23Z",
    style: {
      fill: "#dc897c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.85,276s-4.75,3.65-5,4.25-1.34,3.35-1.15,3.48,4.12,1.82,4.12,1.82l3.78-3.53s1.51-2.49,1.4-4.14Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403,230.72c3.37.4,7.27,11.09,7.27,11.09l-10.34,4.24S395.06,229.78,403,230.72Z",
    style: {
      fill: "#CC1DDE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.72,269.43l-26.07,1c-6.47-37.07-3.43-37.77-3.43-37.77a54.85,54.85,0,0,1,6.16-1.77l.37-.07c1.71-.34,2.06-.38,4.33-.67,3.86-.3,7.44-.48,11.83-.43l.84,0c.8,0,1.58.06,2.33.1l1.51.11,1.64.17c2.79.29,4.77.64,4.77.64C398.12,252.47,398.19,258.94,398.72,269.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.67,244.13a21.64,21.64,0,0,1-2.46,10.93c-1-7.21-1.49-12.1-1.63-15.42C370.55,239.69,372.52,240.64,372.67,244.13Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.05,360.65c-6.6,25.15-19,55-19,55L362.73,414l12.61-53.31Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.31,413.18c.13-.57-6.91-1.82-6.91-1.82s-5.32,3.29-9.69,3.25-2.68,3,2,4.14l11.44,2.8C369.39,422.35,368,419.05,369.31,413.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.33,412.24a1,1,0,0,1-.57-.32.67.67,0,0,1,0-.78.81.81,0,0,1,.48-.38,3,3,0,0,1,1.6.21c-.49-.43-.9-.92-.83-1.29s.25-.4.6-.47a1.11,1.11,0,0,1,.9.19,4.15,4.15,0,0,1,1,2.46.17.17,0,0,1,0,.07h0s0,0,0,.05h0l0,0h0a.09.09,0,0,1-.07,0A8.94,8.94,0,0,1,358.33,412.24Zm.88-1.07a1.68,1.68,0,0,0-.85,0,.37.37,0,0,0-.26.19c-.13.25-.07.35,0,.38.26.34,1.62.27,2.75.09A9,9,0,0,0,359.21,411.17Zm.82-1.59a.62.62,0,0,0-.33,0c-.11,0-.29.07-.31.17-.06.32.8,1.1,1.73,1.74a3.09,3.09,0,0,0-.82-1.78A.75.75,0,0,0,360,409.58Z",
    style: {
      fill: "#CC1DDE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.86,265.81s9.71,20.48,6.28,39.8-13.8,44.14-16.6,50.15-13.23,41.65-13.23,41.65l-9-2.94s8.07-35.36,10.6-47.68c1.2-5.82,11.45-47.27,11.45-47.27S370.77,286.47,372,266Z",
    style: {
      fill: "#CC1DDE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.28,394.47l9,2.94s10.44-35.63,13.24-41.65c1.44-3.09,4.88-11.18,8.36-20.93,3.27-9.18,6.57-19.85,8.23-29.22,3.43-19.33-6.28-39.8-6.28-39.8L372,266c-1.25,20.43,16.33,33.48,16.33,33.48l-4,16.18c-3,12.32-6.77,27.71-7.46,31.09C374.35,359.1,366.28,394.47,366.28,394.47Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.3,370.73a400.78,400.78,0,0,1,11.61,39.33l-4.39,1.47-18.34-40.8Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.09,406.72c-.27-.51-6.48,3-6.48,3s-2,5.93-5.39,8.69-.14,4,4.15,1.94L422,415.22C425,413.74,421.84,412.07,419.09,406.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410,413a1,1,0,0,1-.64.12c-.17,0-.4-.18-.48-.61a.74.74,0,0,1,.13-.6,2.87,2.87,0,0,1,1.36-.85c-.66,0-1.28-.14-1.46-.47a.65.65,0,0,1,.16-.75,1.09,1.09,0,0,1,.82-.42c1-.06,2.3,1.16,2.36,1.22a.16.16,0,0,1,0,.07h0a.14.14,0,0,1,0,.06h0a.13.13,0,0,1,0,.06h0l0,.07A9.1,9.1,0,0,1,410,413Zm0-1.38a1.86,1.86,0,0,0-.69.5.43.43,0,0,0-.08.32c.06.28.17.31.21.32.42.1,1.43-.83,2.18-1.69A8.6,8.6,0,0,0,410,411.63Zm-.39-1.75a.64.64,0,0,0-.26.21c-.07.08-.17.24-.12.32.15.28,1.31.34,2.44.24a3.2,3.2,0,0,0-1.77-.85A.7.7,0,0,0,409.65,409.88Z",
    style: {
      fill: "#CC1DDE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.28,394.47l9,2.94s10.44-35.63,13.24-41.65c1.44-3.09,4.88-11.18,8.36-20.93l-3.21-27.94s3.84-2.25,6.24-10.91a13.89,13.89,0,0,1-7.44,3.25c-1,.07-4.12,6.65-8.15,16.47-3,12.32-6.77,27.71-7.46,31.09C374.35,359.1,366.28,394.47,366.28,394.47Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370,311a100.54,100.54,0,0,0,6.86,24.11c3.57,8.29,7.51,14.39,10.38,20.68C392.33,367,405.81,397,405.81,397l10.36-3.6s-14.41-40.49-19.9-49.43c0,0-3.43-29.05-3.77-44.76,0,0,3.68-3.25,4.92-10.74,1.31-7.9-25.05-20-25.05-20A103,103,0,0,0,370,311Z",
    style: {
      fill: "#CC1DDE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370,311a100.54,100.54,0,0,0,6.86,24.11c3.57,8.29,7.51,14.39,10.38,20.68C392.33,367,405.81,397,405.81,397l10.36-3.6s-14.41-40.49-19.9-49.43c0,0-3.43-29.05-3.77-44.76,0,0,3.68-3.25,4.92-10.74,1.31-7.9-25.05-20-25.05-20A103,103,0,0,0,370,311Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.19 270.6 376.15 270.81 375.98 266.59 390.03 266.74 390.19 270.6",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "374.75 266.57 374.91 270.83 373.49 270.85 373.11 266.56 374.75 266.57",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "391.27 266.75 398.72 266.83 399.05 270.46 391.42 270.58 391.27 266.75",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.3,230.68s1.49-4.62,9.78-6,13.8-1.53,11,6.94S376.3,230.68,376.3,230.68Z",
    style: {
      fill: "#CC1DDE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.22,232.62c-3.93,1.82-8.5,13.43-8.5,13.43l8.5,4.51,3.45-6.43s.83-4.44,0-7.4A6.64,6.64,0,0,0,369.22,232.62Z",
    style: {
      fill: "#CC1DDE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.23,230.08c.22,17.27-17.33,50.73-17.33,50.73s-9.49,3.24-16.15,0c0,0-4,7.47-4,7.91a1.39,1.39,0,0,0,1.41,1.4s-3.84,9.53.2,12.42,17.5,2.37,19.45-.09,1.33-19.65,1.33-19.65,16.12-31.12,17.27-52.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.11,282.8s.62,17.18-1.33,19.65-15.41,3-19.44.09-.21-12.43-.21-12.43a1.39,1.39,0,0,1-1.42-1.4c0-.44,4-7.9,4-7.9,6.67,3.24,16.15,0,16.15,0s17.55-33.46,17.34-50.73l2.14.26C399.24,251.68,383.11,282.8,383.11,282.8Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.9,280.81s-2,9.88-6,10.29-12.78-1-12.78-1a1.39,1.39,0,0,1-1.42-1.4c0-.44,4-7.9,4-7.9C371.42,284.05,380.9,280.81,380.9,280.81Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutParking);
export default __webpack_public_path__ + "static/media/about_parking.686ffb4bb178cc5f85d7efc1fd8394ad.svg";
export { ForwardRef as ReactComponent };